<div *ngIf="object" class="ui-g ui-fluid clear-ui">
    <div class="ui-g-12">
        <h1 class="card__title--h1 color--white layout-page-title">Allocation Definition</h1>
    </div>
    <div class="ui-g-12">
        <!-- Left Side -->
        <div class="card">
            <div class="ui-g form-group">
                <div class="ui-g-3">
                    <div class="p-float-label">
                        <input type="text" pInputText [(ngModel)]="object.Description" />
                        <label>Description</label>
                    </div>
                </div>
                <div class="ui-g-3">
                </div>
                <div class="ui-g-3">
                    <div class="p-float-label">
                        <p-dropdown [(ngModel)]="object.OverrideDirectPosting" class="dropdown-reportDefinitions"
                            [options]="yesNoOptions" optionLabel="label" optionValue="value" [autoDisplayFirst]="false"
                            placeholder="Select Yes or No">
                        </p-dropdown>
                        <label>Override Direct Postings</label>
                    </div>

                </div>
                <div class="ui-g-6">
                    <modal-allocation-item-picker buttonText="Allocation Item"
                        [(allocationItemId)]="object.AllocationItemId" [companyId]="object.CompanyId">
                    </modal-allocation-item-picker>
                </div>
                <div class="ui-g-3">
                    <div class="p-float-label">
                        <input type="number" pInputText [(ngModel)]="object.ProcessingOrder"
                            ng-pattern="/^-?[0-9][^\.]*$/" />
                        <label>Processing Order</label>
                    </div>
                </div>
                <div class="ui-g-3">
                </div>
            </div>

            <div *ngIf="object.AllocationItemId" class="ui-g">
                <div class="ui-g-12">
                    <app-dimension-picker label="Source Dimension" header="Pick"
                        [(dimensionId)]="object.SourceDimensionId" [companyId]="this.companyId"></app-dimension-picker>
                </div>
                <div *ngIf="object.SourceDimensionId" class="ui-g-12">
                    <div class="ui-float-label">
                        <modal-dimension-value-picker buttonText="Source Dimension Value"
                            [(dimensionValueId)]="object.SourceDimensionValueId"
                            [(dimensionId)]="object.SourceDimensionId">
                        </modal-dimension-value-picker>
                    </div>
                </div>
                <div *ngIf="object.SourceDimensionValueId" class="ui-g-12">
                    <app-dimension-picker label="Target Dimension" header="Pick"
                        [(dimensionId)]="object.TargetDimensionId" [companyId]="this.companyId"></app-dimension-picker>
                </div>
            </div>

            <div *ngIf="id != 'new' && object.AllocationItemId && object.SourceDimensionId && object.SourceDimensionValueId && object.TargetDimensionId"
                class="ui-g">
                <div class="ui-g-2">
                    <div class="p-float-label">
                        <p-dropdown [options]="years" [(ngModel)]="year" dataKey="value" optionLabel="name"
                            (onChange)="getItems($event)">
                        </p-dropdown>
                        <label>Year:</label>
                    </div>
                </div>
                <div class="ui-g-6">
                </div>
                <div #allocationFactorsGridContainer class="ui-g-12">

                    <ejs-grid #GridAllocationFactors id="GridAllocationFactors" name="GridAllocationFactors"
                        [dataSource]="items" [pageSettings]="{ pageSize: 100}" [height]="gridHeight" width="100%"
                        [toolbar]='toolbar' [editSettings]='editSettings' [allowSorting]="true"
                        (beforeBatchAdd)="onBeforeBatchAdd($event)" [selectionSettings]='selectionOptions'
                        [filterSettings]="filterOptions" [allowFiltering]="true" [enableAutoFill]='true'
                        (rowDataBound)="onRowDataBound($event)" (dataBound)="onGridDataBound()"
                        [sortSettings]="sortOptions" [allowResizing]="true"
                        [clipboardSettings]="clipboardSettings" (cellSelected)="onCellSelected($event)">
                        <e-columns>
                            <e-column type="checkbox" headerText=" " width="30" textAlign="Center"
                                [allowSelecting]="false"></e-column>
                            <e-column field="ID" headerText="ID " width="70" textAlign="Center" isPrimaryKey='true'
                                [visible]="false" type='number' [allowSelecting]="false"></e-column>

                            <e-column field="TargetDimensionValueID" headerText="Target Dimension Value" width="150"
                                foreignKeyField="id" foreignKeyValue="name" [dataSource]="dimensionValuesList"
                                editType="dropdownedit" [allowSelecting]="false" [validationRules]="{ required: true }">
                            </e-column>
                            <e-column field="I" headerText="I " width="70" [validationRules]="checkMonthValueRule"
                                textAlign="Center" format='N4' type='number'></e-column>
                            <e-column field="II" headerText="II " width="70" [validationRules]="checkMonthValueRule"
                                textAlign="Center" format='N4' type='number'></e-column>
                            <e-column field="III" headerText="III " width="70" [validationRules]="checkMonthValueRule"
                                textAlign="Center" format='N4' type='number'></e-column>
                            <e-column field="IV" headerText="IV " width="70" [validationRules]="checkMonthValueRule"
                                textAlign="Center" format='N4' type='number'></e-column>
                            <e-column field="V" headerText="V " width="70" [validationRules]="checkMonthValueRule"
                                textAlign="Center" format='N4' type='number'></e-column>
                            <e-column field="VI" headerText="VI " width="70" [validationRules]="checkMonthValueRule"
                                textAlign="Center" format='N4' type='number'></e-column>
                            <e-column field="VII" headerText="VII " width="70" [validationRules]="checkMonthValueRule"
                                textAlign="Center" format='N4' type='number'></e-column>
                            <e-column field="VIII" headerText="VIII " width="70" [validationRules]="checkMonthValueRule"
                                textAlign="Center" format='N4' type='number'></e-column>
                            <e-column field="IX" headerText="IX " width="70" [validationRules]="checkMonthValueRule"
                                textAlign="Center" format='N4' type='number'></e-column>
                            <e-column field="X" headerText="X " width="70" [validationRules]="checkMonthValueRule"
                                textAlign="Center" format='N4' type='number'></e-column>
                            <e-column field="XI" headerText="XI " width="70" [validationRules]="checkMonthValueRule"
                                textAlign="Center" format='N4' type='number'></e-column>
                            <e-column field="XII" headerText="XII " width="70" [validationRules]="checkMonthValueRule"
                                textAlign="Center" format='N4' type='number'></e-column>
                            <e-column field="Year" headerText="Year" width="70" textAlign="Center" [visible]="false"
                                type='number'></e-column>
                        </e-columns>
                        <e-aggregates>
                            <e-aggregate>
                                <e-columns>
                                    <e-column field="I" type="sum" format="N4">
                                        <ng-template #footerTemplate let-data>
                                            <span [ngStyle]="{'color': data.sum == 1.00 ? 'green' : 'red'}"
                                                (change)="onAggregateChange('I', data.sum)">
                                                Sum: {{ data.sum }}
                                            </span>

                                        </ng-template>
                                    </e-column>
                                    <e-column field="II" type="sum" format="N4">
                                        <ng-template #footerTemplate let-data>
                                            <span [ngStyle]="{'color': data.sum == 1.00 ? 'green' : 'red'}"
                                                (change)="onAggregateChange('II', data.sum)">
                                                Sum: {{ data.sum }}
                                            </span>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="III" type="sum" format="N4">
                                        <ng-template #footerTemplate let-data>
                                            <span [ngStyle]="{'color': data.sum == 1.00 ? 'green' : 'red'}"
                                                (change)="onAggregateChange('II', data.sum)">
                                                Sum: {{ data.sum }}
                                            </span>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="IV" type="sum" format="N4">
                                        <ng-template #footerTemplate let-data>
                                            <span [ngStyle]="{'color': data.sum == 1.00 ? 'green' : 'red'}"
                                                (change)="onAggregateChange('IV', data.sum)">
                                                Sum: {{ data.sum }}
                                            </span>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="V" type="sum" format="N4">
                                        <ng-template #footerTemplate let-data>
                                            <span [ngStyle]="{'color': data.sum == 1.00 ? 'green' : 'red'}"
                                                (change)="onAggregateChange('V', data.sum)">
                                                Sum: {{ data.sum }}
                                            </span>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="VI" type="sum" format="N4">
                                        <ng-template #footerTemplate let-data>
                                            <span [ngStyle]="{'color': data.sum == 1.00 ? 'green' : 'red'}"
                                                (change)="onAggregateChange('VI', data.sum)">
                                                Sum: {{ data.sum }}
                                            </span>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="VII" type="sum" format="N4">
                                        <ng-template #footerTemplate let-data>
                                            <span [ngStyle]="{'color': data.sum == 1.00 ? 'green' : 'red'}"
                                                (change)="onAggregateChange('VII', data.sum)">
                                                Sum: {{ data.sum }}
                                            </span>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="VIII" type="sum" format="N4">
                                        <ng-template #footerTemplate let-data>
                                            <span [ngStyle]="{'color': data.sum == 1.00 ? 'green' : 'red'}"
                                                (change)="onAggregateChange('VIII', data.sum)">
                                                Sum: {{ data.sum }}
                                            </span>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="IX" type="sum" format="N4">
                                        <ng-template #footerTemplate let-data>
                                            <span [ngStyle]="{'color': data.sum == 1.00 ? 'green' : 'red'}"
                                                (change)="onAggregateChange('IX', data.sum)">
                                                Sum: {{ data.sum }}
                                            </span>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="X" type="sum" format="N4">
                                        <ng-template #footerTemplate let-data>
                                            <span [ngStyle]="{'color': data.sum == 1.00 ? 'green' : 'red'}"
                                                (change)="onAggregateChange('X', data.sum)">
                                                Sum: {{ data.sum }}
                                            </span>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="XI" type="sum" format="N4">
                                        <ng-template #footerTemplate let-data>
                                            <span [ngStyle]="{'color': data.sum == 1.00 ? 'green' : 'red'}"
                                                (change)="onAggregateChange('XI', data.sum)">
                                                Sum: {{ data.sum }}
                                            </span>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="XII" type="sum" format="N4">
                                        <ng-template #footerTemplate let-data>
                                            <span [ngStyle]="{'color': data.sum == 1.00 ? 'green' : 'red'}"
                                                (change)="onAggregateChange('XII', data.sum)">
                                                Sum: {{ data.sum }}
                                            </span>

                                        </ng-template>
                                    </e-column>
                                </e-columns>
                            </e-aggregate>

                        </e-aggregates>
                    </ejs-grid>


                </div>
            </div>
            <div class="ui-g-12">
                <button
                    *ngIf=" object.AllocationItemId && object.SourceDimensionId && object.SourceDimensionValueId && object.TargetDimensionId"
                    type="button" label="Save" pButton icon="ui-icon-save"
                    (click)="saveAllocationDefinition()"></button>
                <button
                    *ngIf=" object.AllocationItemId && object.SourceDimensionId && object.SourceDimensionValueId && object.TargetDimensionId"
                    type="button" label="Save & Close" pButton icon="ui-icon-save"
                    (click)="saveAllocationDefinition(true)"></button>
                <button type="button" label="Cancel" pButton icon="ui-icon-cancel" (click)="backToMenu()"></button>
            </div>
            <div class="ui-g">
                <div class="ui-g-12">
                    <p *ngIf="sumError" style="color: red"><b>All allocation factor sums must equal exactly 1.0000 and
                            all lines must have Target Dimension Value specified in order to save changes</b></p>
                </div>
            </div>

        </div>
    </div>
</div>
